<template>
    <div class="CShareTelegram">
        <CButton class="w-full" icon="telegram" label-class="sm:hidden" variant="telegram" @click="telegramLink">
            Telegram
        </CButton>
    </div>
</template>

<script setup lang="ts">
import { useSharing } from '@/composables/sharing/useSharing'

interface Props {
    url: string
    title?: string
}

const props = withDefaults(defineProps<Props>(), {
    title: ''
})

const { objectToGetParams } = useSharing()

const telegramLink = () => {
    window.open(
        'https://telegram.me/share/' +
            objectToGetParams({
                url: props.url,
                text: props.title
            }),
        '__blank'
    )
}
</script>
